"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _variables = _interopRequireDefault(require("./variables.graphql"));
var _reactRedux = require("react-redux");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Metrics = function Metrics(props) {
  var selectedDataConnector = props.selectedDataConnector,
    handlePicking = props.handlePicking;
  var assignmentId = (0, _reactRedux.useSelector)(function (state) {
    return state.flow.builder.assignmentId;
  });
  var onSelect = function onSelect(row) {
    props.onSelect({
      category: 'metrics',
      id: row.variableId,
      name: 'value',
      title: row.label || row['key.metric'],
      type: 'string'
    });
  };
  var selected = selectedDataConnector && selectedDataConnector.category === 'metrics' ? selectedDataConnector.id : null;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    query: _variables["default"],
    rowKey: "variableId",
    graphqlVariables: {
      assignmentId: assignmentId,
      typeFilter: ['quantitative', 'qualitative', 'formula', 'additional_coding', 'summary_usage']
    },
    filter: selected ? {
      variableId: selected.toString()
    } : {},
    perPage: 10,
    columns: [{
      name: 'variableId',
      label: 'Id',
      filter: true,
      filterSettings: {
        type: 'regex',
        preparePattern: function preparePattern(value) {
          return "^".concat(value, "$");
        }
      }
    }, {
      name: 'key.title',
      label: 'Question',
      filter: true
    }, {
      name: 'key.metric',
      label: 'Metric',
      filter: true
    }, {
      name: 'reportHeader',
      label: 'Variable',
      filter: true
    }, {
      name: 'label',
      label: 'Label',
      filter: true
    }, {
      name: 'survey.label',
      label: 'Survey',
      filter: true
    }],
    onRowClick: onSelect,
    setRowClass: function setRowClass(row) {
      return selected === row.variableId ? _style["default"].selected : '';
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "btn btn-sm btn-primary",
    disabled: !selected,
    onClick: handlePicking
  }, "Select")));
};
Metrics.propTypes = {
  selectedDataConnector: _propTypes["default"].object,
  onSelect: _propTypes["default"].func,
  handlePicking: _propTypes["default"].func
};
var _default = Metrics;
exports["default"] = _default;